import { OptionItemInfoText } from '../OptionItem';
import OptionItem from '../OptionItem/OptionItem';

import styles from './MethodOption.module.css';

export interface MethodOptionProps {
  className?: string;
  methodName: string;
  description?: string;
  loading?: boolean;
  disabled?: boolean;
  methodIconSrc?: string;
  customIcon?: JSX.Element;
  infoText?: string;
  onClick: () => void;
}

export default function MethodOption({
  className,
  methodName,
  customIcon,
  methodIconSrc,
  infoText,
  ...otherProps
}: MethodOptionProps): JSX.Element {
  return (
    <OptionItem
      {...otherProps}
      name={methodName}
      icon={
        <div className={styles['icon-wrapper']}>
          {customIcon ? (
            customIcon
          ) : (
            <img src={methodIconSrc} alt={methodName} />
          )}
        </div>
      }
      disabled={otherProps.disabled}
      rightBottomSlot={infoText && <OptionItemInfoText text={infoText} />}
    />
  );
}
